import _ from 'lodash';

function DateRangeService(model) {
    var self = this;
    self.model = model;

    if (_.isNil(self.model)) {
        throw new Error('Model is undefined at DateRangeService!');
    }
}

DateRangeService.prototype = {
    getAvailableRanges: function () {
        var self = this;
        return self.model.getAvailableRanges();
    },

    getCurrentRange: function () {
        var self = this;
        return self.model.getCurrentRange();
    },

    getLiveModeStatus: function () {
        var self = this;
        return self.model.getLiveModeStatus();
    },

    setAvailableRanges: function (ranges) {
        var self = this;
        self.model.setAvailableRanges(ranges);
    },

    setCurrentRange: function (range) {
        var self = this;
        self.model.setCurrentRange(range);
    },

    setLiveModeStatus: function (status) {
        var self = this;
        self.model.setLiveModeStatus(status);
    }
};

export default DateRangeService;
